import { render } from "./SearchDisplay.vue?vue&type=template&id=98a3745a"
import script from "./SearchDisplay.vue?vue&type=script&lang=js"
export * from "./SearchDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__